<template>
    <client-page class="app--main">
        <!-- S:: 채용공고 비주얼 -->
        <v-container class="container--large">
            <main-visual code="recruitment-pc" pc></main-visual>
            <main-visual code="recruitment-mobile" mobile></main-visual>
        </v-container>
        <!-- E:: 채용공고 비주얼 -->

        <section class="section">
            <v-container class="container--large">
                <recruitment-list-toggle />
                <!-- <main-recruitment-tit title="전체 채용공고">
                    <template #actions> <recruitment-list-filter /> </template>
                </main-recruitment-tit> -->
                <recruitment-list-filter class="mb-10 mb-md-20 mb-lg-28" />
                <template v-if="items.length">
                    <v-row class="my-n10 my-lg-n20">
                        <template v-for="item in items.slice(0, 8)">
                            <v-col cols="12" sm="6" md="3" :key="item._id" class="py-10 py-lg-20">
                                <main-recruitment-card :recruitment="item" />
                            </v-col>
                        </template>

                        <template v-if="4 < items.slice(0, 8).length">
                            <v-col cols="12">
                                <main-banner code="recruitment-sub-1-pc" pc class="my-40 my-lg-80" />
                                <main-banner code="recruitment-sub-1-mobile" mobile class="my-40 my-lg-80" />
                            </v-col>
                        </template>

                        <template v-for="item in items.slice(8, 16)">
                            <v-col cols="12" sm="6" md="3" :key="item._id">
                                <main-recruitment-card :recruitment="item" />
                            </v-col>
                        </template>

                        <template v-if="4 < items.slice(8, 16).length">
                            <v-col cols="12">
                                <main-banner code="recruitment-sub-2-pc" pc class="my-40 my-lg-80" />
                                <main-banner code="recruitment-sub-2-mobile" mobile class="my-40 my-lg-80" />
                            </v-col>
                        </template>
                    </v-row>

                    <div class="mt-40 mt-lg-60">
                        <v-pagination :value="page" :length="pageCount" :total-visible="11" color="primary" class="my-16" @input="(page) => $router.push({ query: { ...$route.query, page } })"></v-pagination>
                    </div>
                </template>
                <template v-else>
                    <v-layout column justify-center align-center class="page-text page-text--lg border-top pt-12 pt-lg-20"> 등록된 채용공고가 없습니다. </v-layout>
                </template>
            </v-container>
        </section>
    </client-page>
</template>

<script>
import api from "@/api";
import { RECRUITMENT_LIST_SORTS, RECRUITMENT_STATES, USER_LIKE_TYPES } from "@/assets/variables";

import ClientPage from "@/pages/client/templates/ClientPage.vue";
import MainVisual from "@/components/client/main/main-visual.vue";
import MainBanner from "@/components/client/main/main-banner.vue";

import MainRecruitmentCard from "@/components/client/main/main-recruitment-card.vue";
import RecruitmentListFilter from "@/components/client/recruitments/list/recruitment-list-filter.vue";
import RecruitmentListToggle from "@/components/client/recruitments/list/recruitment-list-toggle.vue";

export default {
    components: {
        ClientPage,
        MainVisual,
        MainBanner,

        MainRecruitmentCard,
        RecruitmentListFilter,
        RecruitmentListToggle,
    },
    data: () => ({
        recruitments: [],

        limit: 16,
        summary: { totalCount: 0 },

        loading: false,
        showsSearch: true,
        USER_LIKE_TYPES,
    }),
    computed: {
        items() {
            return this.recruitments.map((item, index) => ({ ...item, index: this.summary.totalCount - (this.page - 1) * this.limit - index }));
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        sort() {
            const key = this.$route.query.sort || RECRUITMENT_LIST_SORTS.CREATED_AT_DESC.value;
            let { sort } = RECRUITMENT_LIST_SORTS[key] || {};

            if (sort) sort = JSON.stringify(sort);

            return sort;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { ...query } = this.$route.query;

            if (query.sort) {
                let sortParams = RECRUITMENT_LIST_SORTS[query.sort]?.params?.() || {};
                query = { ...query, ...sortParams };
                delete query.sort;
            }

            if (query?.["employment.place.address1"]) {
                if (!Array.isArray(query?.["employment.place.address1"])) {
                    query["employment.place.address1"] = [query?.["employment.place.address1"]].filter((item) => item);
                }
                if (query["employment.place.address1"]?.includes?.("전국")) {
                    query["employment.place.isAbroad"] = false;
                    delete query["employment.place.address1"];
                }
                if (query["employment.place.address1"]?.includes?.("전체")) {
                    delete query["employment.place.isAbroad"];
                    delete query["employment.place.address1"];
                }
            }

            query["application.endsAt"] = [null, { $gte: new Date() }];

            query.state = [RECRUITMENT_STATES.ON_GOING.value];
            // query.state = [RECRUITMENT_STATES.ON_GOING.value, RECRUITMENT_STATES.FINISHED.value]; 
            
            return { ...query };
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        params() {
            this.search();
        },
    },
    methods: {
        init() {
            this.search();
        },
        async search() {
            this.loading = true;
            try {
                let { skip, limit, sort, params } = this;

                var { summary, recruitments } = await api.v1.recruitments.gets({
                    headers: { skip, limit, sort },
                    params,
                });

                this.recruitments = recruitments;
                this.summary = summary;
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
